import * as React from 'react';
import { useForkRef } from '@cian/react-utils';
import { valueToPercent } from '../helpers';
import { useSliderValueState } from './useSliderValueState';
import { useMouseTouchController } from './useMouseTouchController';
import { useSliderMarks } from './useSliderMarks';
import { useSliderValueThumbs } from './useSliderValueThumbs';
import { useSliderHelpers } from './useSliderHelpers';
export function useSliderController(props) {
  const {
    min,
    max
  } = props;
  const sliderRef = React.useRef(null);
  const marks = useSliderMarks(props);
  const valueState = useSliderValueState(props);
  const {
    roundValue
  } = useSliderHelpers({
    props,
    marks
  });
  const {
    sliderRef: handleThumbsSliderRef,
    thumbs,
    setFocusIndex,
    setActiveIndex,
    setOpenIndex
  } = useSliderValueThumbs({
    props,
    valueState,
    marks
  });
  const {
    range,
    values
  } = valueState;
  const {
    onMouseDown
  } = useMouseTouchController({
    props,
    valueState,
    sliderRef,
    setFocusIndex,
    setActiveIndex,
    setOpenIndex,
    roundValue
  });
  const trackOffset = valueToPercent(range ? values[0] : min, min, max);
  const trackLeap = valueToPercent(values[values.length - 1], min, max) - trackOffset;
  const handleSliderRef = useForkRef(sliderRef, handleThumbsSliderRef);
  return {
    sliderRef: handleSliderRef,
    trackOffset,
    trackLeap,
    valueState,
    onMouseDown,
    thumbs,
    marks
  };
}